import PropTypes from 'prop-types';
import React from 'react';

export class HtmlNumberInput extends React.Component {
  handleMinus = () => {
    let answer = parseInt(this.input.value, 10);
    if (isNaN(answer)) {
      answer = this.props.lowerBound;
    } else if (answer > this.props.lowerBound) {
      answer -= 1;
    }

    this.input.value = answer;
    this.props.onChange(this.input.value);
  }

  handlePlus = () => {
    let answer = parseInt(this.input.value, 10);
    if (isNaN(answer)) {
      answer = this.propslowerBound;
    } else if (answer < this.props.upperBound) {
      answer += 1;
    }

    this.input.value = answer;
    this.props.onChange(this.input.value);
  }

  handleInputValue = (e) => {
    const inputValue = parseInt(e.key, 10);
    if (isNaN(inputValue)) {
      e.preventDefault();
    }
  }

  numberOnBlur = (event) => {
    let wasChanged = false;
    if (event.target.value > this.props.upperBound) {
      this.input.value = this.props.upperBound;
      wasChanged = true;
    } else if (event.target.value < this.props.lowerBound) {
      this.input.value = this.props.lowerBound;
      wasChanged = true;
    }
    if (wasChanged) {
      this.props.onChange(this.input.value);
    }
  };

  numberOnChange= () => {
    const inputValue = parseInt(this.input.value, 10);
    if (!isNaN(inputValue)) {
      this.props.onChange(this.input.value);
    }
  }

  render() {
    const opts = {};
    opts.disabled = this.props.disabled;
    return (
      <div className="input-group number-spinner">
        {!this.props.isRightToLeft ?
        <span className="input-group-btn">
          <button className="btn btn-default" type="button" onClick={this.handleMinus}
            data-qa-item="minus" disabled={this.props.disabled}
          >
          {this.props.minusIndicator}
          </button>
        </span> :
        <span className="input-group-btn">
          <button className="btn btn-default" type="button" onClick={this.handlePlus}
            disabled={this.props.disabled} data-qa-item="plus"
          >
          {this.props.plusIndicator}
          </button>
        </span>
        }
        <input type="text"
          className="form-control"
          ref={ (input) => { this.input = input; } }
          data-qa-item={this.props.qaTag}
          onBlur={this.numberOnBlur}
          onChange={this.numberOnChange}
          onKeyPress={this.handleInputValue}
          value={this.props.value}
          {...opts}
        />
        {!this.props.isRightToLeft ?
        <span className="input-group-btn">
          <button className="btn btn-default" type="button" onClick={this.handlePlus}
            disabled={this.props.disabled} data-qa-item="plus"
          >
          {this.props.plusIndicator}
          </button>
        </span>
         :
         <span className="input-group-btn">
          <button className="btn btn-default" type="button" onClick={this.handleMinus}
            data-qa-item="minus" disabled={this.props.disabled}
          >
          {this.props.minusIndicator}
          </button>
         </span>
        }
      </div>
    );
  }
}

HtmlNumberInput.propTypes = {
  disabled: PropTypes.bool,
  lowerBound: PropTypes.number,
  upperBound: PropTypes.number,
  value: PropTypes.number,
  onChange: PropTypes.func,
  qaTag: PropTypes.string,
  minusIndicator: PropTypes.string,
  plusIndicator: PropTypes.string,
  isRightToLeft: PropTypes.bool,
};
